import React, { useEffect } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import BackPageHeader from '../../components/ui/header/BackPageHeader'
import { Section } from '../../styles/sections'
import { Title, Text2, Text1Bold, SubTitle } from '../../components/ui/text'
import theme from '../../styles/theme'
import { getStudyBySlug } from '../../constants/imagingStudies'
import ContactHelpCard from '../../components/ui/contactHelpCard'
import {
	ClinicCard,
	ClinicHeader,
	ClinicInfo,
	ClinicLogo,
	Grid,
	Header,
	Schedule
} from './styled'
import { useMobileBack } from '../../context/MobileBackContext'

const StudyDetail = ({ match }) => {
	const history = useHistory()
	const { setCustomBack } = useMobileBack()
	const study = getStudyBySlug(match.params.studyId)

useEffect(() => {
	setCustomBack(() => () => history.push('/inicio/novedades'))
	return () => setCustomBack(null)
}, [setCustomBack, history])

	if (!study) {
		return <Redirect to="/inicio/novedades" />
	}
	return (
		<Section>
			<BackPageHeader onBack={() => history.goBack()} title="" showBack />
			<Header>
				<Title size="24px" mobileSize="20px" color={theme.colors.text.primaryText}>
					{study.title}
				</Title>
				{study.subtitle && (
					<Text2
						size="16px"
						mobileSize="14px"
						fontWeight={400}
						color={theme.colors.text.secondaryText}
					>
						{study.subtitle}
					</Text2>
				)}
			</Header>
			<Grid>
				{study.centers.map(center => (
					<ClinicCard key={center.name}>
						<ClinicHeader>
							<ClinicLogo src={center.logo} alt={center.name} />
							<ClinicInfo>
								<Text1Bold size="16px" color={theme.colors.text.primaryText}>
									{center.name}
								</Text1Bold>
								<SubTitle size="14px" color={theme.colors.text.secondaryText}>
									{center.address}
								</SubTitle>
							</ClinicInfo>
						</ClinicHeader>
						<Schedule>
							{center.schedule.map(line => (
								<SubTitle key={line} size="14px" color={theme.colors.text.secondaryText}>
									{line}
								</SubTitle>
							))}
						</Schedule>
					</ClinicCard>
				))}
			</Grid>
			<ContactHelpCard
				title="¿Buscás otra clínica o centro?"
				description={
					'Si no encontrás la sede que necesitás, comunicate al 0800-666-6587 o por\nWhatsApp al 11 4493-2017, de lunes a viernes de 8:00 a 20:00 hs.'
				}
			/>
		</Section>
	)
}

export default StudyDetail
